import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";


import { ReactiveFormsModule } from '@angular/forms';
import { IndexComponent } from "./views/index/index.component";
import { FormsModule } from '@angular/forms'; // ← important
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from "src/environments/environment";
import { SucessComponent } from './sucess/sucess.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,

    IndexComponent,

    SucessComponent,
    
  ],
  imports: [BrowserModule, AppRoutingModule,
        ReactiveFormsModule // ✅ Add this
        ,FormsModule,
                    AngularFireModule.initializeApp(environment.firebaseConfig),
                    AngularFireDatabaseModule,HttpClientModule


  ],
  providers: [],
  bootstrap: [AppComponent,],
})
export class AppModule {}
